import { NavLink } from 'react-router-dom';
import { clsx } from 'clsx';
import styles from './Navbar.module.scss';

interface Props {
  classes?: string;
  mobile?: boolean;
  style?: React.CSSProperties;
  closeMenu?: () => void;
}
const Navbar = ({
  classes = '',
  mobile = false,
  style = {},
  closeMenu = () => {},
}: Props) => {
  return (
    <nav className={`${styles.nav} container-fluid d-flex `} style={style}>
      <ul
        className={`container m-auto ${classes} ${
          mobile ? styles.mobile_menu : styles.menu
        }`}
      >
        <li className={clsx(styles.menuItem, mobile && styles.mobile_menuItem)}>
          <NavLink
            to='/'
            className={({ isActive }) =>
              isActive
                ? `${styles.active} ${styles.stethoscope}`
                : styles.stethoscope
            }
            end
            onClick={closeMenu}
          >
            Inicio
          </NavLink>
        </li>
        <li className={clsx(styles.menuItem, mobile && styles.mobile_menuItem)}>
          <NavLink
            to='/agenda'
            className={({ isActive }) =>
              isActive ? `${styles.active} ${styles.calendar}` : styles.calendar
            }
            onClick={closeMenu}
          >
            Agenda
          </NavLink>
        </li>
        <li className={clsx(styles.menuItem, mobile && styles.mobile_menuItem)}>
          <NavLink
            to='/pacientes'
            className={({ isActive }) =>
              isActive
                ? `${styles.active} ${styles['address-book']}`
                : styles['address-book']
            }
            onClick={closeMenu}
          >
            Pacientes
          </NavLink>
        </li>
        <li className={clsx(styles.menuItem, mobile && styles.mobile_menuItem)}>
          <NavLink
            to='/prescripciones'
            className={({ isActive }) =>
              isActive
                ? `${styles.active} ${styles['add-document']}`
                : styles['add-document']
            }
            onClick={closeMenu}
          >
            Prescripciones
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
